<template>
    <div class="view">
        <div class="checked">
            <slot name="checkBox"></slot>
        </div>
        <div style="height: 100%">
            <img class="item-view-img" :src="show_img" v-on:error="imageFailed"/>
        </div>

        <div class="view-con">
            <el-tooltip class="item" effect="dark" content="素材尺寸" placement="top">
                <span>{{ info.width }} * {{ info.height }}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="素材大小" placement="top">
                <span>{{ info.material_size }}{{ info.material_size_unit }}</span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="素材格式" placement="top">
                <span>{{ info.material_format }}</span>
            </el-tooltip>
        </div>

    </div>
</template>
<script>
import noImg from '@/assets/img/mi-no-img.png';
export default {
    name: 'preview',
    props: {
        info: {
            type: Object,
            default: function () {
                return {
                    // "wid": "1826862",
                    // "material_name": "狂野风暴-缓存图.png",
                    // "material_md5": "f538a5118997141f9d85c64a9fcf3e5b",
                    // "upload_time": "2025/12/12",
                    // "material_url": "https://material.jutou.wankacn.com/plat/WorkOrder2/Attachment2222/2025-01-02/uZFW0t1asJoKZQn9Ct1v/WupC27ZMvaWe9Mpu8wr6.png",
                    // "img_material_url": "https://material.jutou.wankacn.com/plat/WorkOrder2/Attachment2222/2025-01-02/uZFW0t1asJoKZQn9Ct1v/WupC27ZMvaWe9Mpu8wr6.png",
                    // "height": "2400",
                    // "width": "1080",
                    // "material_size": "762.76",
                    // "material_size_unit": "KB",
                    // "material_duration": "-",
                    // "material_format": "png",
                    // "material_type": "1",
                    // "refusal_reason": ""
                }
            }
        }
    },
    data() {
        return {
            no_img: noImg,
            show_img: '',
        }
    },
    watch:{
        info:{
            handler(newValue, oldValue){
                this.show_img = newValue.material_url
            },
            immediate:true,
            deep: true
        }
    },
    methods: {
        // imageLoaded() {
        //     this.show_img = this.info.material_url
        // },
        imageFailed() {
            this.show_img = this.no_img
        }
    }
}
</script>
<style scoped lang="scss">
.view {
    border: 1px solid #DCDFE6;
    position: relative;
    margin-bottom: 20px;
    // height: calc(100vh - 320px);
    height: 40vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 25px;

    .checked{
        position: absolute;
        top: 16px;
        right: 12px;
    }

    .item-view-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        cursor: pointer;
    }

    .view-con {
        font-size: 12px;
        position: absolute;
        width: 100%;
        background-color: #ecf5ffc4;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        padding: 4px;
        bottom: 0;

        span {
            cursor: pointer;
        }
    }

    .relative {
        position: relative;
        height: 100%;

        .fullScreen {
            position: absolute;
            right: 12px;
            bottom: 60px;
            font-size: 22px;
            color: #fff;
        }
    }
}
</style>